import Axios from "axios";
import qs from "qs";

export class VirtualSport {
  constructor(apiUrl, headers) {
    this.virtualSportUrl = `${apiUrl}/virtual-sport`;
    this.headers = headers;
  }

  async getAdminCobeProject() {
    const url = `${this.virtualSportUrl}/projects`;

    const response = await Axios.get(url, {
      headers: this.headers,
    });

    return response;
  }

  async list(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true,
      indices: false,
    });

    const url = `${this.virtualSportUrl}/records${queryString}`;

    const response = await Axios.get(url, {
      headers: this.headers,
    });

    return response;
  }

  async getDetail(recordId) {
    const url = `${this.virtualSportUrl}/records/${recordId}`;

    const response = await Axios.get(url, {
      headers: this.headers,
    });

    return response;
  }

  async patch(recordId, data) {
    const url = `${this.virtualSportUrl}/records/${recordId}`;

    const response = await Axios.patch(url, data, {
      headers: this.headers,
    });

    return response;
  }
}
